import BaseService from './BaseService'
import ResellingService from './ResellingService'
import config from "../config"

const PRODUCT_ID = 'seo_search_atlas'

class SeoResellingService extends BaseService {
  resellingService: ResellingService
  constructor(baseUrl: string) {
    super(baseUrl)
    this.resellingService = new ResellingService(config.resellingBaseUrl, PRODUCT_ID)
  }

  getProductConfiguration = () => this.resellingService.getProductConfiguration()

  getCompanyResellingConfig = (companyId: string) => this.resellingService.getCompanyResellingConfiguration(companyId)

  updateCompanyResellingConfig = (
    companyId: string,
    data: { amount?: number; offeringEnabled?: boolean }
  ) => this.resellingService.updateCompanyResellingConfiguration(companyId, data)

  getLocationConfig = (locationId: string) => this.resellingService.getLocationResellingConfiguration(locationId)

  getLocationSubscriptions = (locationId: string) => this.resellingService.getLocationSubscriptions(locationId)

  updateLocationResellingConfig = (
    locationId: string,
    data: any
  ) => this.resellingService.updateLocationResellingConfiguration(locationId, data)

  agencyDirectPurchase = (locationId: string, planId: string, affiliatePayload: any) =>
    this.resellingService.agencyDirectPurchaseV2(locationId, planId, affiliatePayload)

  getCompanySubscriptions = (companyId: string) => this.resellingService.getCompanySubscriptions(companyId)
}

const instance = new SeoResellingService(
  BaseService.servicesConfig.Seo as string
)

export default instance
